import { Box, Image } from '@chakra-ui/react';

interface IPhotoButton {
  slotId: number;
  imagePath: string;
  onPreviewImage: (path: string) => void;
}

function PhotoButton(props: IPhotoButton) {
  return (
    <Box
      boxSize={'80px'}
      border="1px"
      borderColor={'#eeeeee'}
      borderRadius="base"
      overflow="hidden"
      onClick={() => {
        props.onPreviewImage(props.imagePath);
      }}>
      <Image src={props.imagePath} fit="cover" w={'100%'} h={'100%'} />
    </Box>
  );
}

export default PhotoButton;
